import { Component, ElementRef, Input, OnInit } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { SecurityTransferSaveModalInput } from '../../../../model/single-transaction/security-transfer/security-transfer.model'
import { setHighestZIndexForOpenModals } from '../../../../util/common-utils'
import { TransactionConstants } from '../../../../util/constants'

@Component({
  selector: 'hs-save-confirm-modal',
  template: `
    <div class="modal-header" hsDraggable="modal-dialog">
      <h4 class="modal-title">Warning</h4>
      <button
        nf-icon-button
        icon="close"
        class="btn-bare"
        ngbTooltip="Close"
        (click)="activeModal.close()"
      >
        Close
      </button>
    </div>
    <div class="modal-body" hsDraggable="modal-dialog">
      <p>
        {{ saveModalInput?.warningMessage }}
      </p>
    </div>
    <div class="modal-footer" hsDraggable="modal-dialog">
      <button nf-button="cancel" (click)="activeModal.dismiss()"></button>
      <button nf-button="submit" (click)="activeModal.close(true)">Save</button>
    </div>
  `,
})
export class SecurityTransferSaveConfirmationModalComponent implements OnInit {
  @Input() saveModalInput?: SecurityTransferSaveModalInput

  readonly compId = TransactionConstants.SECURITY_WARNING_COMP_ID

  constructor(
    public activeModal: NgbActiveModal,
    private readonly eleRef: ElementRef,
  ) {}

  ngOnInit() {
    setHighestZIndexForOpenModals(this.compId, this.eleRef)
  }

  getComponentId() {
    return this.compId
  }
}
